import { render, staticRenderFns } from "./graphicVersoesSistemas.vue?vue&type=template&id=0c2900d3&scoped=true&"
import script from "./graphicVersoesSistemas.vue?vue&type=script&lang=js&"
export * from "./graphicVersoesSistemas.vue?vue&type=script&lang=js&"
import style0 from "./graphicVersoesSistemas.vue?vue&type=style&index=0&id=0c2900d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2900d3",
  null
  
)

export default component.exports